/* shto-women-paid: moves the progress bar with the review cards (the cards are moved by shto-swipe.js) and hides it when everything fits. */
(function () {
  function init(root) {
    if (root.shtoWomenPaid) return;
    root.shtoWomenPaid = true;
    var cards = root.querySelector('.shto-women-paid__cards');
    var progress = root.querySelector('.shto-women-paid__progress');
    var bar = root.querySelector('.shto-women-paid__bar');
    if (!cards || !progress || !bar) return;
    function update() {
      var max = cards.scrollWidth - cards.clientWidth;
      var scrolls = max > 1;
      progress.style.visibility = scrolls ? '' : 'hidden';
      if (!scrolls) return;
      var travel = progress.clientWidth - bar.offsetWidth;
      bar.style.transform = 'translateX(' + (Math.min(Math.max(cards.scrollLeft, 0), max) / max) * travel + 'px)';
    }
    cards.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function initAll(scope) {
    scope.querySelectorAll('[data-shto-section="shto-women-paid"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
